import { styled } from '@mui/material/styles';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import { Dialog, Paper, TableRow, Typography } from '@mui/material';
import { GridOverlay } from '@mui/x-data-grid';


export default function NoDataFoundMessage() {
  return (
    <GridOverlay>
      <Typography variant="h6" color="textSecondary">
        No record found
      </Typography>
    </GridOverlay>
  );
}

export const formatValueWithDecimalPlaces = (value, decimalPlaces = 2, currency = false) => {
  if (value === '' || value == null) return '';

  const numericValue = Number(value);
  if (!Number.isFinite(numericValue)) return '';

  return new Intl.NumberFormat('en-CA', {
    ...(currency ? { style: 'currency', currency: 'CAD' } : {}),
    minimumFractionDigits: decimalPlaces,
    maximumFractionDigits: decimalPlaces
  }).format(numericValue);
};

export const limitDecimalPlaces = (value, decimalPlaces = 5) => {
  const [integerPart, ...fractionalParts] = String(value).split('.');
  if (fractionalParts.length === 0) return String(value);

  return `${integerPart}.${fractionalParts.join('').slice(0, decimalPlaces)}`;
};

export const formatDecimalValue = (value, decimalPlaces = 5) => {
  if (value === '' || value == null) return '';

  const numericValue = Number(value);
  return Number.isFinite(numericValue) ? numericValue.toFixed(decimalPlaces) : '';
};

export const formatAbsoluteEditingValue = (value, decimalPlaces = 5) =>
  value == null
    ? ''
    : limitDecimalPlaces(String(value).replace(/^[+-]/, ''), decimalPlaces);

export const AccountTypeData = [
  { label: 'All In One', value: 1 },
  { label: 'DAP', value: 6 },
  { label: 'TFSA', value: 7 },
  { label: 'RRSP', value: 8 },
  // { label: 'TFSA', value: 0 },
  { label: 'SpRRSP', value: 9 },
  { label: 'LIRA', value: 10 },
  { label: 'RRIF', value: 11 },
  { label: 'LIF', value: 13 },
  { label: 'LRSP', value: 20 },
  { label: 'Corporate Margin', value: 21 },
  { label: 'Individual Single RESP', value: 22 },
  { label: 'Individual Family RESP', value: 23 },
  { label: 'Joint Single RESP', value: 24 },
  { label: 'Joint Family RESP', value: 25 },
  { label: 'Joint Non-Registered', value: 26 }
];

export const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14
  },
  '&:nth-of-type(odd)': {
    backgroundColor: '#124734',
    color: theme.palette.common.white
  },
  '&:nth-of-type(even)': {
    backgroundColor: '#0e3a2a',
    color: theme.palette.common.white
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0
  }
}));

export const StyledTableCellData = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.body}`]: {
    fontSize: 13
  },

  '&:nth-of-type(odd) ': {
    backgroundColor: '#efefef',
    color: '#2a2a2a'
  },
  '&:nth-of-type(even) td': {
    backgroundColor: '#f5f5f5',
    color: '#2a2a2a'
  },
  // hide last border
  '&:last-child td, &:last-child td': {
    border: 0
  }
}));

export const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover
  },
  '&:nth-of-type(even) td': {
    backgroundColor: '#f5f5f5',
    color: '#2a2a2a'
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0
  }
}));


export const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

export const blockSpecialChar = (e) => {

  const { key } = e;

  const allowedPattern = /^[a-zA-Z0-9\s]+$/;

  if (!allowedPattern.test(key)) {
    e.preventDefault();
    return false;
  }
}


export const StyledTableCellSecond = styled(TableCell)(({ theme }) => ({

  [`&.${tableCellClasses.head}`]: {
    color: theme.palette.common.white
  },
  '&:nth-of-type(odd)': {
    padding: '3px 8px',
    minHeight: 100
  },
  '&:nth-of-type(even)': {
    padding: '3px 8px',
    minHeight: 100
  },
  [`&.${tableCellClasses.root}`]: {
    padding: '3px 8px',
    minWidth: 80,
    fontSize: 14,
    color: 'black'
  },
  '.css-rpurbm-MuiInputBase-input-MuiOutlinedInput-input.MuiInputBase-inputSizeSmall': {
    padding: '4px 11px'
  }
}));

export const  ActivityListItemWrapper = styled('div')(({ theme }) => ({
    // cursor: 'pointer',
    padding: 16,
    '&:hover': {
        background: theme.palette.primary.light
    },
    '& .MuiListItem-root': {
        padding: 0
    }
}));

export const WhiteContainer = styled(Paper)(({ theme }) => ({
  ...theme.typography.body2,
  padding: theme.spacing(2),
  // padding: '0',
  // textAlign: 'center',
  color: theme.palette.text.secondary,
}));

export const getStatusColor = (status) => {
  switch (status) {
    case 'Active':
      return 'success';
    case 'Pending':
      return 'warning';
    case 'Rejected':
      return 'error';
    default:
      return 'default';
  }
};

export const lightColors = [
  '#F2F4F8', // Light grayish blue
  '#E2F0CB', // Light pastel green
  '#F5E1DA', // Light peach
  '#D8E0F3', // Light sky blue
  '#F0E6F4', // Light lavender
  // '#FFFAE3', // Light yellow
  '#E0F7FA', // Light cyan
  '#F1F8E9', // Light green
  '#FFF3E0', // Light orange
  '#F3E5F5', // Light purple
  '#EDE7F6', // Light violet
  '#E1F5FE', // Light baby blue
  '#FFF8E1', // Light cream
  '#FCE4EC', // Light pink
  '#E8F5E9', // Light mint green
  '#FFEBEE', // Light rose
  '#F9FBE7', // Light lime
  '#E3F2FD', // Light azure
  '#E0F2F1', // Light teal
  // '#FFEB3B', // Light sunny yellow
];

export const getRandomColor = () => {
  return lightColors[Math.floor(Math.random() * lightColors.length)];
};


/* export const getRandomColor = () => {
  const letters = '0123456789ABCDEF';
  let color = '#';
  for (let i = 0; i < 6; i++) {
    color += letters[Math.floor(Math.random() * 16)];
  }
  return color;
}; */

export const formatDateDMY = (timestamp) => {
  const date = new Date(timestamp);
  return new Intl.DateTimeFormat('en-US', { year: 'numeric', month: 'long', day: 'numeric' }).format(date);
};

export const formatDateMonthYear = (dateString) => {
  const date = new Date(dateString);

  const day = date.getUTCDate();
  const month = date.toLocaleString('default', { month: 'long' });
  const year = date.getUTCFullYear();

  // Get the day suffix (st, nd, rd, th)
  const getDaySuffix = (day) => {
    if (day > 3 && day < 21) return 'th'; // 11th, 12th, 13th, etc.
    switch (day % 10) {
      case 1: return 'st';
      case 2: return 'nd';
      case 3: return 'rd';
      default: return 'th';
    }
  };

  const dayWithSuffix = `${day}${getDaySuffix(day)}`;

  return `${dayWithSuffix} ${month}-${year}`;
};

export const parentSteps = [
    {
        step: 0,
        permissions: [
            'Household Role',
            'Personal Information',
            'Address',
            'Financial',
            'Regulatory'
        ]
    },
    {
        step: 1,
        permissions: [
            'Account Type & Information',
            'Beneficiary Information',
            'Transfer Details',
            'Bank Information',
            'EFT Details',
            'PAC Details',
            'SWP Details',
            'Income Sweep'
        ]
    },
    {
        step: 2,
        permissions: [
            'Input',
            'Portfolio View',
            'Enhancements',
            'Notes',
            'Submit for Approval',
            'Save and Send to Manager'
        ]
    },
    {
        step: 3,
        permissions: ['Review']
    },
    {
        step: 4,
        permissions: ['Agreement']
    },
    {
        step: 5,
        permissions: ['Thank You']
    }
];

const storedPermissions = localStorage.getItem('manager_permissions');
const parsedPermissions = storedPermissions ? JSON.parse(storedPermissions) : {};
const hasPermission = (permissionName) => Object.prototype.hasOwnProperty.call(parsedPermissions, permissionName);

export const isStepAllowed = (step) => {
    const stepData = parentSteps.find(item => item.step === step);

    if (!stepData) {
        return false;
    }

    return stepData.permissions.some(permission =>
        hasPermission(permission)
    );
};

export const getNextAllowedStep = (currentStep) => {
    for (let step = currentStep + 1; step < parentSteps.length; step++) {
        if (isStepAllowed(step)) {
            return step;
        }
    }
    return currentStep;
};


export const getPreviousAllowedStep = (currentStep) => {
    for (let step = currentStep - 1; step >= 0; step--) {
        if (isStepAllowed(step)) {
            return step;
        }
    }

    return currentStep;
};


export const smallMenuItemSx = {
    width: '150px',
    '& .MuiInputBase-root': {
        height: '30px',
    },
    '& .MuiSelect-select': {
        minHeight: '30px !important',
        boxSizing: 'border-box',
        display: 'block',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        lineHeight: '30px',
        py: '0 !important',
  }
}
